"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessRules = exports.BusinessRulesPreselectParams = void 0;
var tslib_1 = require("tslib");
var lists_1 = require("src/lists");
var search_1 = require("src/search");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var FilterableListService_1 = require("Views/Partials/Components/FilterableList/FilterableListService");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var HierarchyService_1 = require("./HierarchyService");
var SearchResultsService_1 = require("./SearchResultsService");
var documentationArchivedPresentedValue = false;
var BusinessRulesPreselectParams = /** @class */ (function () {
    function BusinessRulesPreselectParams() {
        this.archived = documentationArchivedPresentedValue;
    }
    return BusinessRulesPreselectParams;
}());
exports.BusinessRulesPreselectParams = BusinessRulesPreselectParams;
var typeToSegmentAliasMapping = (_a = {},
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Documentation)] = FullTextSearchApi_1.FullTextSearchFilters.DocumentationSegmentFilterAlias,
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Products)] = FullTextSearchApi_1.FullTextSearchFilters.ProductsSegmentFilterAlias,
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Download)] = FullTextSearchApi_1.FullTextSearchFilters.DownloadSegmentFilterAlias,
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Careers)] = FullTextSearchApi_1.FullTextSearchFilters.CareersSegmentFilterAlias,
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Course)] = FullTextSearchApi_1.FullTextSearchFilters.CourseSegmentFilterAlias,
    _a["type:".concat(FullTextSearchApi_1.FullTextSearcherTypes.Drawings)] = FullTextSearchApi_1.FullTextSearchFilters.DrawingsSegmentFilterAlias,
    _a);
var BusinessRules = /** @class */ (function () {
    function BusinessRules() {
        var _this = this;
        this.processPreSelectedRules = function (selectedFiltersList, preselectParams, preselectionEnabled) {
            var filtersList = selectedFiltersList.slice(0);
            var filtersFromUrl = FilterableListService_1.FilterableListService.getFiltersFromUrl().filters;
            var prevTypeFilterValue = SearchResultsService_1.SearchResultsService.getFilterValueItself((0, search_1.getSelectedFilter)(filtersFromUrl, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias));
            var newTypeFilterValue = SearchResultsService_1.SearchResultsService.getFilterValueItself((0, search_1.getSelectedFilter)(filtersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias));
            var isDocumentationTypeSelected = newTypeFilterValue === FullTextSearchApi_1.FullTextSearcherTypes.Documentation;
            var hasTypeFilterChanged = prevTypeFilterValue !== newTypeFilterValue;
            var isDeprecatedDocumentationLanguageFilterSelected = isDocumentationTypeSelected &&
                selectedFiltersList.filter(function (filter) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter) === 'language'; }).length > 0;
            var isDeprecatedDocumentationArchivedFilterSelected = isDocumentationTypeSelected &&
                selectedFiltersList.filter(function (filter) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter) === 'archived'; }).length > 0;
            if (!isDeprecatedDocumentationLanguageFilterSelected) {
                _this.applySelectionRules({
                    filterAlias: FullTextSearchApi_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
                    allSelectedValue: FullTextSearchApi_1.FullTextSearchApiConst.ALL_LANGUAGES,
                    preselectedValue: preselectParams.preselectedLanguagesDocuments,
                }, filtersList, filtersFromUrl, isDocumentationTypeSelected, hasTypeFilterChanged, preselectionEnabled);
            }
            if (!isDeprecatedDocumentationArchivedFilterSelected) {
                _this.applySelectionRules({
                    filterAlias: FullTextSearchApi_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
                    allSelectedValue: FullTextSearchApi_1.FullTextSearchApiConst.ALL_ARCHIVED_OPTIONS,
                    preselectedValue: Boolean(preselectParams.archived).toString(),
                }, filtersList, filtersFromUrl, isDocumentationTypeSelected, hasTypeFilterChanged, preselectionEnabled);
            }
            filtersList = _this.removeDeprecatedCareersLanguageFilter(filtersList);
            return filtersList;
        };
        this.getPreselectedFiltersArray = function (serviceConfig) {
            var preselectedLanguagesDocuments = serviceConfig.preselectedLanguagesDocuments;
            var preselectedFilters = [];
            if (preselectedLanguagesDocuments && preselectedLanguagesDocuments.length) {
                preselectedFilters = preselectedLanguagesDocuments.map(function (language) {
                    return "".concat(FullTextSearchApi_1.FullTextSearchFilters.DocumentationLanguageFilterAlias, ":").concat(language);
                });
            }
            preselectedFilters.push("".concat(FullTextSearchApi_1.FullTextSearchFilters.DocumentationArchivedFilterAlias, ":").concat(documentationArchivedPresentedValue));
            return preselectedFilters;
        };
        this.processProductTypeRule = function (filteredData) {
            // removing ProductType filter as not every segment have it yet
            var productTypeFilterIndex = (0, lists_1.findIndex)(filteredData.filters, function (item) {
                return item.typeAlias === FilterTypings_1.FilterGroupTypeAlias.ProductType;
            });
            filteredData.filters = (0, lists_1.removeByIndex)(filteredData.filters, productTypeFilterIndex);
            return filteredData;
        };
        // make careers location filter active, when country is selected
        this.processCareersLocationRule = function (filteredData, selectedFiltersList) {
            var courseAlias = FullTextSearchApi_1.FullTextSearchFilters.CareersCountryFilterAlias;
            var isCountrySelected = !!(0, search_1.getSelectedFilter)(selectedFiltersList, courseAlias);
            if (!isCountrySelected)
                return filteredData;
            filteredData.filters.forEach(function (filter) {
                if (filter.value === FullTextSearchApi_1.FullTextSearchFilters.CareersLocationFilterAlias) {
                    filter.isDisabled = false;
                    filter.isHidden = false;
                }
            });
            return filteredData;
        };
        this.processHierarchyRules = function (filteredData, selectedFiltersList, dictionary, documentsHierarchyConfiguration) {
            if (documentsHierarchyConfiguration === void 0) { documentsHierarchyConfiguration = {}; }
            var selectedType = (0, search_1.getSelectedFilter)(selectedFiltersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
            var segmentAlias = typeToSegmentAliasMapping[selectedType] || FullTextSearchApi_1.FullTextSearchFilters.AllSegmentFilterAlias;
            var selectedSegment = (0, search_1.getSelectedFilter)(selectedFiltersList, segmentAlias);
            if (selectedSegment) {
                if (selectedType.indexOf(FullTextSearchApi_1.FullTextSearcherTypes.Course) !== -1) {
                    _this.resolveCourseHierarchy(filteredData.filters, selectedSegment, dictionary);
                }
                else if (selectedType.indexOf(FullTextSearchApi_1.FullTextSearcherTypes.Documentation) !== -1 ||
                    selectedType.indexOf(FullTextSearchApi_1.FullTextSearcherTypes.Drawings) !== -1 ||
                    selectedType.indexOf(FullTextSearchApi_1.FullTextSearcherTypes.Download) !== -1) {
                    switch (documentsHierarchyConfiguration[selectedSegment]) {
                        case HierarchyService_1.HIERARCHY_TYPE.marketingHierarchy:
                            _this.resolveDocumentsWithMarketingHierarchy(filteredData.filters, selectedSegment, dictionary);
                            break;
                        case HierarchyService_1.HIERARCHY_TYPE.productHierarchy:
                            _this.resolveDocumentsWithProductHierarchy(filteredData.filters, selectedSegment, dictionary);
                            break;
                        case HierarchyService_1.HIERARCHY_TYPE.withoutHierarchy:
                            _this.resolveDocumentsWithoutHierarchy(filteredData.filters);
                            break;
                    }
                    _this.applyAdditionalLogicForDrivesSegment(filteredData.filters, selectedSegment);
                }
            }
            return filteredData;
        };
        this.processSegmentSelectionRules = function (selectedFiltersList) {
            var selectedType = (0, search_1.getSelectedFilter)(selectedFiltersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
            var segmentAlias = typeToSegmentAliasMapping[selectedType] || FullTextSearchApi_1.FullTextSearchFilters.AllSegmentFilterAlias;
            var isSegmentSelected = !!(0, search_1.getSelectedFilter)(selectedFiltersList, segmentAlias);
            var isDocumentTypeSelected = !!(0, search_1.getSelectedFilter)(selectedFiltersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias, FullTextSearchApi_1.FullTextSearcherTypes.Documentation);
            var isCourseTypeSelected = !!(0, search_1.getSelectedFilter)(selectedFiltersList, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias, FullTextSearchApi_1.FullTextSearcherTypes.Course);
            // if Documentation or Course is selected but segment is not
            // show message to select segment
            return (isCourseTypeSelected || isDocumentTypeSelected) && !isSegmentSelected;
        };
        // Documents search page rules.
        // All other type filters except documentation are removed, suggestions are cleared.
        this.processDocumentsSearchPageRules = function (filteredData, documentsSearchPageType) {
            var filtersListWithDocumentationOnlyTypeFilter = filteredData.filters.map(function (filter) {
                if (filter.value === FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias) {
                    var documentationFilterValue_1 = "".concat(FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias, ":").concat(documentsSearchPageType);
                    var documentationTypeItem = filter.items.filter(function (item) { return item.value === documentationFilterValue_1; })[0];
                    if (!documentationTypeItem) {
                        console.warn('Documentation type filter is missing');
                    }
                    return tslib_1.__assign(tslib_1.__assign({}, filter), { items: documentationTypeItem ? [documentationTypeItem] : filter.items });
                }
                return filter;
            });
            filteredData.filters = filtersListWithDocumentationOnlyTypeFilter;
            filteredData.suggestions = '';
            return filteredData;
        };
        this.applySelectionRules = function (options, filtersList, filtersFromUrl, isTypeWithPreselectionsSelected, hasTypeFilterChanged, preselectionEnabled) {
            var filterAlias = options.filterAlias, allSelectedValue = options.allSelectedValue, preselectedValue = options.preselectedValue;
            var prevSelection = SearchResultsService_1.SearchResultsService.getFilterValueItself((0, search_1.getSelectedFilter)(filtersFromUrl, filterAlias));
            var currentSelection = SearchResultsService_1.SearchResultsService.getFilterValueItself((0, search_1.getSelectedFilter)(filtersList, filterAlias));
            var preselectNeeded = preselectionEnabled || (!prevSelection && !currentSelection);
            var selectionRemoved = isTypeWithPreselectionsSelected &&
                !hasTypeFilterChanged &&
                prevSelection &&
                !currentSelection;
            if (preselectNeeded && preselectedValue) {
                // adding default selection
                Array.isArray(preselectedValue)
                    ? preselectedValue.forEach(function (preselection) {
                        filtersList.push((0, search_1.encodeFilterValue)(filterAlias, preselection));
                    })
                    : filtersList.push((0, search_1.encodeFilterValue)(filterAlias, preselectedValue));
            }
            else if (selectionRemoved) {
                // all options were removed -> add ALL
                filtersList.push((0, search_1.encodeFilterValue)(filterAlias, allSelectedValue));
            }
        };
        this.removeDeprecatedCareersLanguageFilter = function (filtersList) {
            return filtersList.filter(function (filter) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter) !== 'careersLanguage'; });
        };
        // Specific business logic for filtersList with selected Document type and Drives segment:
        // ProductSeries filter shouldn't have text label
        this.applyAdditionalLogicForDrivesSegment = function (filters, selectedSegment) {
            var DRIVES_SEGMENT = 'dds';
            if (SearchResultsService_1.SearchResultsService.getFilterValueItself(selectedSegment) === DRIVES_SEGMENT) {
                filters.forEach(function (filter) {
                    if (filter.value === FullTextSearchApi_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias) {
                        filter.label = '';
                    }
                });
            }
        };
        // skipping first level and label for Courses type, hierarchy query value already contains first level
        // https://danfoss.visualstudio.com/Danfoss.com/_workitems/edit/79976/
        this.resolveCourseHierarchy = function (filters, selectedSegment, dictionary) {
            var hierarchyFilterIndex = HierarchyService_1.HierarchyService.getHierarchyFilterIndex(filters, FilterTypings_1.FilterGroupTypeAlias.Hierarchy);
            var hierarchyFilter = filters[hierarchyFilterIndex];
            if (hierarchyFilter) {
                var hierarchyDropdowns = HierarchyService_1.HierarchyService.resolveHierarchy(hierarchyFilter, selectedSegment, dictionary, FilterTypings_1.FilterGroupTypeAlias.Hierarchy, dictionary.courseCategory, true);
                filters.splice.apply(filters, tslib_1.__spreadArray([hierarchyFilterIndex, 1], hierarchyDropdowns, false));
            }
        };
        this.resolveDocumentsWithMarketingHierarchy = function (filters, selectedSegment, dictionary) {
            var hierarchyFilterIndex = HierarchyService_1.HierarchyService.getHierarchyFilterIndex(filters, FilterTypings_1.FilterGroupTypeAlias.Hierarchy);
            if (hierarchyFilterIndex !== -1) {
                var hierarchyFilter = filters[hierarchyFilterIndex];
                var hierarchyDropdowns = HierarchyService_1.HierarchyService.resolveHierarchy(hierarchyFilter, selectedSegment, dictionary, FilterTypings_1.FilterGroupTypeAlias.Hierarchy);
                filters.splice.apply(filters, tslib_1.__spreadArray([hierarchyFilterIndex, 1], hierarchyDropdowns, false));
            }
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy);
        };
        this.resolveDocumentsWithProductHierarchy = function (filters, selectedSegment, dictionary) {
            var productHierarchyFilterIndex = HierarchyService_1.HierarchyService.getHierarchyFilterIndex(filters, FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy);
            if (productHierarchyFilterIndex !== -1) {
                var hierarchyFilter = filters[productHierarchyFilterIndex];
                var hierarchyDropdowns = HierarchyService_1.HierarchyService.resolveHierarchy(hierarchyFilter, selectedSegment, dictionary, FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy);
                filters.splice.apply(filters, tslib_1.__spreadArray([productHierarchyFilterIndex, 1], hierarchyDropdowns, false));
            }
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.Hierarchy);
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductSeries);
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductGroup);
        };
        this.resolveDocumentsWithoutHierarchy = function (filters) {
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.Hierarchy);
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy);
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductSeries);
            _this.cleanSpecificHierarchyFilter(filters, FilterTypings_1.FilterGroupTypeAlias.ProductGroup);
        };
        this.cleanSpecificHierarchyFilter = function (filters, typeAlias) {
            var filterIndex = HierarchyService_1.HierarchyService.getHierarchyFilterIndex(filters, typeAlias);
            if (filterIndex !== -1) {
                filters.splice(filterIndex, 1);
            }
        };
    }
    return BusinessRules;
}());
var service = new BusinessRules();
exports.BusinessRules = service;
